import { LabelProps, TagProps } from '@sport1/types/web'

export const getTag = (tags?: (TagProps | LabelProps)[]): TagProps | LabelProps | undefined => {
    if (tags?.length) {
        return tags[tags.length - 1]
    }
    return undefined
}
